import { getStaticProps } from "./[pageId]";
export { getStaticProps };

export { default } from "./[pageId]";
